export const JAMB_SUBJECTS = [
  "English Language",
  "Mathematics",
  "Fine Arts",
  "Music",
  "French",
  "Animal Husbandry",
  "Insurance",
  "Chemistry",
  "Physics",
  "Yoruba",
  "Biology",
  "Geography",
  "Literature in English",
  "Economics",
  "Commerce",
  "Accounts - Principles of Accounts",
  "Government",
  "Igbo",
  "Christian Religious Knowledge (CRK)",
  "Agricultural Science",
  "Islamic Religious Knowledge (IRK)",
  "History",
  "Civic Education",
  "Further Mathematics",
  "Arabic",
  "Home Economics",
  "Hausa",
  "Book Keeping",
  "Data Processing",
  "Catering Craft Practice",
  "Computer Studies",
  "Marketing",
  "Physical Education",
  "Office Practice",
  "Fishery",
];